import { logEvent } from 'commons/utils/tracking';
import { MENU_PRIMARY_META_CLICK } from 'config/trackingEvents';

export const menuPrimaryMetaClick = () => {
  logEvent(MENU_PRIMARY_META_CLICK, {});
};
